<template>
  <div id="top-content" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-md-7">
          <div class="big-title">Looking for an {{name}} alternative?</div>
          <div class="sub-title">
            Meet Verloop, a better, faster and smarter way to interact with your
            customers.
          </div>
        </div>
        <div class="col-md-5">
          <div class="title-signup-area">
            <h2 class="text-center">Join now. Verloop is 100% Free to Get Started.</h2>
            <form id="title-signup-form">
              <div :class="['input-group', isEmailValid()]">
                <input
                  class="form-control"
                  v-model="email"
                  type="email"
                  name="email"
                  placeholder="Your work email"
                />
                <input
                  type="submit"
                  name="submit"
                  value="Create Free Account"
                  @click="createAccount($event)"
                />
              </div>
              <h5 class="text-center">14-day free trial &nbsp;|&nbsp; No Credit Card required</h5>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "top-content",
  props: { name: String },
  data: function() {
    return {
      email: "",
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  methods: {
    isEmailValid() {
      return this.email == ""
        ? ""
        : this.reg.test(this.email)
        ? "has-success"
        : "has-error";
    },
    createAccount(e) {
      e.preventDefault();
      if (this.isEmailValid() != "has-error") {
        window.location.href = `/app/signup/email?utm_source=top-fold&utm_medium=web-client&utm_campaign=direct-click&email=${this.email}`;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.form-control {
  height: 45px;
}
</style>
